// extracted by mini-css-extract-plugin
export default {"studdable-image":"studdable-image__studdable-image___1mi3z"};